(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SoundFont2", [], factory);
	else if(typeof exports === 'object')
		exports["SoundFont2"] = factory();
	else
		root["SoundFont2"] = factory();
})(window, function() {
return 